export { getAvatarFallback } from "./utils/getAvatarFallback";
export { getUniqueColor } from "./utils/getUniqueColor";
export {
	Avatar,
	AvatarImage,
	AvatarLabel,
	AvatarLabelAvatar,
	AvatarLabelDescription,
	AvatarLabelTitle,
} from "ics-ui-kit/components/avatar";
export { AvatarFallback } from "./AvatarFallback";
